
import { SaleEditState } from "@/utils/sale-edit/sale-edit-state";
import Vue from "vue";
import { TranslateResult } from "vue-i18n";
export default Vue.extend({
	props: {
		state: {
			type: Object as ()=>SaleEditState,
			required: true
		}
	},
	computed: {
		message():TranslateResult | null {
			return this.state.processingMessage;
		},
		show():boolean {
			return this.message != null;
		}
	}
});
